/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Settings } from 'luxon';

import { DEFAULT_TIMEZONE, LOCALE_ID_VALUE } from '@shared/utils/locales';

import { LuxonAdapter } from './luxon-adapter';
import { MAT_LUXON_FORMATS } from './luxon-formats';

Settings.defaultLocale = LOCALE_ID_VALUE;
Settings.defaultZone = DEFAULT_TIMEZONE;

export * from './luxon-adapter';
export * from './luxon-formats';

export const luxonAdapterProviders = [
  {
    provide: DateAdapter,
    useClass: LuxonAdapter,
    deps: [MAT_DATE_LOCALE],
  },
  { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_FORMATS },
];
